import { render, staticRenderFns } from "./DefaultColumn.vue?vue&type=template&id=54107504"
import script from "./DefaultColumn.vue?vue&type=script&lang=js"
export * from "./DefaultColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports